// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__ZH-Sq","actions":"GroupTable_actions__1LhZS","deleteModalFooter":"GroupTable_deleteModalFooter__11w9o"};